import React from 'react';
import { SimulationConfig } from './types';
import { SectionLabel } from './SectionLabel';
import { SmartInput } from './SmartInput';

interface AdvancedPhysicsSectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const AdvancedPhysicsSection: React.FC<AdvancedPhysicsSectionProps> = ({ config, setConfig }) => (
  <>
  <div className={`w-full flex flex-col gap-5 p-5 rounded-3xl border ${config.darkMode ? 'bg-zinc-500/5 border-white/5 shadow-sm' : 'bg-zinc-50 border-neutral-100 shadow-sm'} mb-4`}>
    <SmartInput label="Substeps" min={1} max={20} value={config.physicsSubsteps} onChange={v => setConfig(p => ({...p, physicsSubsteps: v}))} darkMode={config.darkMode} settingKey="physicsSubsteps" />
    <SmartInput label="Air Resistance" min={0} max={1.0} step={0.001} value={config.airResistance} onChange={v => setConfig(p => ({...p, airResistance: v}))} darkMode={config.darkMode} settingKey="airResistance" />
    <SmartInput label="Max Velocity" min={5} max={100000} value={config.maxVelocityLimit} onChange={v => setConfig(p => ({...p, maxVelocityLimit: v}))} darkMode={config.darkMode} settingKey="maxVelocityLimit" />
    <SmartInput label="Min Velocity" min={0} max={10000} value={config.minVelocityLimit} onChange={v => setConfig(p => ({...p, minVelocityLimit: v}))} darkMode={config.darkMode} settingKey="minVelocityLimit" />
    <SmartInput label="Anti-Stall Force" min={0} max={10} step={0.1} value={config.antiStallMultiplier} onChange={v => setConfig(p => ({...p, antiStallMultiplier: v}))} darkMode={config.darkMode} settingKey="antiStallMultiplier" />
  </div>
  </>
);